<template>
  <FormPage
    title="Новый менеджер"
    description="Создайте менеджера компании-исполнителя. Телефон — только цифры."
  >
    <template #controls>
    </template>
    <ManagerForm @sendForm="onSubmit" @closeForm="onCancel" />
  </FormPage>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { createToaster } from '@meforma/vue-toaster'
import ManagerForm from '@/components/forms/ManagerForm.vue'
import { invalidateManagersCache } from '@/backend/entitySmartSearchApi'

const toaster = createToaster()

export default {
  name: 'ManagerCreatePage',
  components: { ManagerForm },
  setup() {
    const router = useRouter()
    const store = useStore()

    const onSubmit = async ({ model, form }) => {
      const created = await store.dispatch('apiStorage/addItem', { model, form })
      if (!created) return
      invalidateManagersCache()
      toaster.success('Менеджер добавлен')
      const id = created.id
      if (id != null) {
        router.push({ name: 'ManagerDetail', params: { id: String(id) } })
      } else {
        router.push({ name: 'ManagerList' })
      }
    }

    const onCancel = () => {
      router.push({ name: 'ManagerList' })
    }

    return { onSubmit, onCancel }
  },
}
</script>
